import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
    wrapper: {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadiusBig,
      flex: 1,
      maxWidth: "100%",
      paddingTop: "10%",
      position: "relative",
      textAlign: "center",
    },
    title: {},
    name: {},
    personalNumber: {},
    row: {},
    signatures: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "auto",
      width: "70%",
    },
    signature: {
      borderTop: `1px solid ${theme.palette.common.black}`,
      flex: 1,
      fontSize: "60%",
      lineHeight: "1.3em",
      marginLeft: "2%",
      marginRight: "2%",
    },
    signaturePerson: {},
    signatureTitle: {},
    certifiedSince: {
      fontSize: "60%",
      fontStyle: "italic",
    },
    footer: {
      border: "1px solid red",
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Arial",
    fontSize: 15,
    padding: VoTheme.spacing(4),
  },
  decor: {
    borderBottom: `15px solid ${VoTheme.palette.primary.main}`,
    height: "100%",
    paddingLeft: VoTheme.spacing(4.5),
    paddingRight: VoTheme.spacing(4.5),
    width: "525px",
  },
  title: {
    color: VoTheme.palette.grey[500],
    fontSize: 48,
    fontWeight: 600,
    textAlign: "left",
  },
  subtitle: {
    fontSize: 20,
    fontWeight: 600,
    marginTop: VoTheme.spacing(1),
  },
  person: {
    // fontFamily: "Times-Italic",
    fontSize: 24,
    fontStyle: "italic",
    fontWeight: 500,
    textAlign: "left",
  },
  personalNumber: {
    // fontFamily: "Times-Roman",
    fontSize: 12,
    textAlign: "left",
  },
  text: {
    fontSize: 12,
    // marginTop: VoTheme.spacing(0.5),
    textAlign: "center",
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    maxWidth: 250,
  },
  signaturePerson: {},
  signatureTitle: {},

  logoWrapper: {
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    marginBottom: VoTheme.spacing(1),
    marginLeft: VoTheme.spacing(-4.5),
    marginRight: VoTheme.spacing(-4.5),
  },
  logo: {
    height: "auto",
    width: 100,
  },
  text1: {},
  text2: {},
  educator: {},
  place: {},
  date: {},
  footer: {
    marginTop: VoTheme.spacing(15),
  },
  educatorCertified: {
    marginTop: VoTheme.spacing(7),
  },
  uid: {
    bottom: 4,
    left: 0,
    position: "absolute",
  },
});
